import { fetchEvents } from "../lib/api";
import { EVENTS_BANNER } from "../lib/volunteerVisuals";
import { ListingPage } from "../components/community/ListingPage";

const HERO = { eyebrow: "Events", title: "Be the Change Through Participation", img: EVENTS_BANNER, alt: "Families at a community festival",
  sub: "Join local events that bring communities together.", cta: "Create a Ripple", cta2: "Attend an Event" };

export default function Events() {
  return <ListingPage mode="event" fetcher={fetchEvents} hero={HERO} emptyText="No upcoming events match yet — try all of Canada or another category."
    note="Only upcoming events are shown; past events are removed automatically. Attend, volunteer and sponsor links go to each organizer's own website." />;
}
